import * as React from 'react';
export const IcProtectionLocked = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 14.28V14a3 3 0 00-6 0v.28A2 2 0 0013 16v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zM17 19a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2zm4.46-9.31a2 2 0 00-1.3-.69 18.78 18.78 0 01-6.34-1.83 1.86 1.86 0 00-1.64 0A18.5 18.5 0 014.88 4 2.06 2.06 0 003 6v5c0 5.92 5.21 9.93 8 10.81V15a6 6 0 016-6 5.93 5.93 0 014 1.54V6a2 2 0 00-.54-1.31z'
      fill='currentColor'
    />
  </svg>
);
